export default "__VITE_ASSET__39f2b0b6__"